import { makeAutoObservable, runInAction } from "mobx";

export default class schedulePlanStore {
  schedulePlan = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.schedulePlan = [];
    runInAction(() => {
      this.schedulePlan = data;
    });
  };

  deleteSchedulePlan = (id) => {
    let newState = this.schedulePlan.filter((schedulePlan) => schedulePlan.id !== id);
    this.schedulePlan = [];
    this.schedulePlan = newState;
  };
}
